<template>
	<transition name="slide-fade">
		<div class="new-user"
		     v-if="getReqUserRole === 'Администратор уровня Бог' || getReqUserRole === 'Power User'">
			<button @click="hiddenAuth"
			        v-show="show"></button>
			<h1>Новый пользователь</h1>
			<form action=""
			      class="user-data"
			      autocomplete="off">
				<label for="user">login</label>
				<input type="text"
				       id="user"
				       @focus="test"
				       placeholder="login"
				       autocomplete="false">
				<label for="pass">password</label>
				<input type="password"
				       @focus="test"
				       id="pass"
				       placeholder="password"
				       autocomplete="false">
				<label for="confirm">confirm password</label>
				<input type="password"
				       @focus="test"
				       id="confirm"
				       placeholder="confirm password"
				       autocomplete="false">
				<label for="operator" v-if="getReqUserRole === 'Администратор уровня Бог'">Оператор</label>
				<select id="operator"
				        v-if="getReqUserRole === 'Администратор уровня Бог'"
				        v-model="operator">
					<option v-for="item in operatorList"
					        :value="item.name"
					        :key="item.name"
					>{{item.display_name }}
					</option>
				</select>
				<label for="role"
				       v-if="getReqUserRole === 'Администратор уровня Бог' || getReqUserRole === 'Power User'">Роль пользователя</label>
				<select name="role"
				        id="role"
				        v-model="roleNewUser"
				        v-if="getReqUserRole === 'Администратор уровня Бог' || getReqUserRole === 'Power User'">
					<option :value="1">PowerUser</option>
					<option :value="2">Operator</option>
				</select>
				<input type="submit"
				       value="Зарегистрировать"
				       @click.prevent="createUser">
				<div class="message"></div>
			</form>
		</div>
	</transition>
</template>
<script>
import { mapGetters } from "vuex";
import { performRequest } from "../script/ws/wsclient";

export default {
	name: "NewUser",
	data() {
		return {
			show: true,
			operatorList: '',
			operator: '',
			roleNewUser: 2
		};
	},
	beforeMount() {
		performRequest(
			{
				section: "tvcontent.operator",
				name:    "getOperatorList"
			},
			{},
			a => {
				if (a.code === 200) {
					this.operatorList = a.data;
					console.log(a);
				} else {
					console.log("ошибка загрузки списка операторов");
				}
			});
		this.operator = this.getViewUser;
	},
	methods: {
		hiddenAuth() {
			this.$router.go(-1);
		},
		createUser() {
			let inputs = document.querySelectorAll(".user-data input");
			let message = document.querySelector(".message");
			let login = inputs[0].value;
			let pass = inputs[1].value;
			if (login === "" || [].slice.call(login).length <= 4) {
				message.innerText = "логин слишком короткий";
			} else if ([].slice.call(pass).length <= 4) {
				message.innerText = "пароль слишком короткий";
			} else if (pass !== inputs[2].value) {
				message.innerText = "пароли не совпадают";
			} else {
				message.innerText = "";
				this.buttonCreateUser(login, pass, this.operator);
				inputs[0].value = "";
				inputs[1].value = "";
				inputs[2].value = "";
			}
		},
		test() {
			let message = document.querySelector(".message");
			message.innerText = "";
		},
		buttonCreateUser(login, pass, operator) {
			let command = {};
			let data = {};
			let message = document.querySelector(".message");

			data.login = login;
			data.password = pass;
			data.role = this.roleNewUser;
			data.operator = operator;

			command.section = "authorize";
			command.name = "createUser";
			performRequest(command, data, a => {
				if (a.code === 200) {
					message.classList.add("message-suc");
					message.innerText = "Пользователь создан";
					setTimeout(() => {
						this.$router.go(-1);
						message.classList.remove("message-suc");
					}, 2000);
				} else if (a.data === "User already exists") {
					message.innerText = "Пользователь существует!";
				} else {
					message.innerText = "Неведомая ошибка!!!";
				}
			});
		}
	},
	computed: {
		...mapGetters(["getReqUserRole", "getViewUser"])
	}
};
</script>
<style scoped lang="scss">
.new-user {
	position: absolute;
	margin-top: 5rem;
	width: 20rem;
	background-color: rgba(238, 238, 238, 0.8);
	border-radius: 0.5rem;
	right: 50%;
	transform: translateX(50%);
	box-shadow: inset 0 0 5px #333333;

	button {
		position: absolute;
		height: 2rem;
		width: 2rem;
		background: transparent url('../../static/close.png') no-repeat center;
		background-size: 75%;
		margin: 2px;
		right: 0;
		border: none;
		cursor: pointer;
		outline: none;
	}

	h1 {
		font-size: 1.5rem;
		text-align: center;
		padding-top: 2rem;
		font-weight: normal;
	}

	.incorrect_pass {
		margin-top: -0.1rem;
		margin-bottom: 2rem;
		font-size: 1.1rem;
		border: none;
		color: #761112;
		text-align: center;
	}

	form {
		display: flex;
		flex-direction: column;

		& input, p, select {
			height: 25px;
			margin: 0 1rem;
			border-radius: 3px;
			outline: none;
			border: 1px solid #c9c9c9;
			padding-left: 5px;

			&:focus {
				box-shadow: 0 0 5px #69bf8f;
			}
		}

		& label {
			margin: 1rem 1rem 0.5rem 1rem;
			color: #37282f;
		}

		& input[type='submit'] {
			background: #bbf291;
			transition: all 0.2s;
			cursor: pointer;
			margin: 2rem 1rem;

			&:hover {
				background: #78956b;
				color: white;
			}

			&:active {
				box-shadow: 0 0 1rem #967068;
			}
		}

		& input[type='button'] {
			background: rgba(154, 203, 121, 0.5);
			transition: all 0.2s;
			cursor: pointer;
			margin-top: 0;
			margin-bottom: 2rem;

			&:hover {
				background: #78956b;
				color: white;

				&:active {
					box-shadow: 0 0 1rem #967068;
				}
			}

			@media (max-width: 620px) {
				.auth {
					margin-top: 9rem;
				}
			}
		}
	}

	.user-data {
		.message {
			text-align: center;
			color: red;
			padding-bottom: 1rem;
		}

		.message-suc {
			text-align: center;
			color: green;
			font-size: 1.4rem;
			padding-bottom: 1rem;
		}
	}
}

.slide-fade-enter-active {
	transition: all 0.3s ease;
}

.slide-fade-leave-active {
	transition: all 0.3s ease;
}

.slide-fade-enter, .slide-fade-leave-to {
	transform: translateX(10px);
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/NewUser.vue